import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useApprovedStudents() {
    return useQuery({
        queryKey: ['approved-students'],
        queryFn: () => apiClient('/approved-students'),
        staleTime: 1000 * 60 * 3,
    });
}
export function useCreateApprovedStudent() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/approved-students', { method: 'POST', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['approved-students'] }),
    });
}
export function useUpdateApprovedStudent(id) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient(`/approved-students/${id}`, { method: 'PATCH', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['approved-students'] }),
    });
}
export function useDeleteApprovedStudent() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiClient(`/approved-students/${id}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['approved-students'] }),
    });
}
//# sourceMappingURL=useApprovedStudents.js.map